import React from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { CheckCircle2 } from "lucide-react";
import { Separator } from "../ui/separator";

const ConfirmationView = ({
  userData,
  isAdminMode,
  onReturnToAdmin,
  onExit,
  cessao,
}) => {
  const [timeoutStatus, setTimeoutStatus] = React.useState(3);


const wppPhone = userData?.processos?.[0]?.processo?.whatsapp_confirmacao;
  const wppMsg   = userData?.processos?.[0]?.processo?.whatsapp_confirmacao_msg;
  const shouldRedirect = !cessao && !!wppPhone;
  const contatoMsg = userData?.processos?.[0]?.processo?.mensagem_contato_duvidas
    || "Dúvidas? Entre em contato: (11) 93333-3012";

  React.useEffect(() => {
    if (timeoutStatus === 0 && shouldRedirect) {
      try {
        const text = encodeURIComponent(
          wppMsg ||
          `Olá! Acabei de assinar os documentos.\nNome: ${userData.nomeCompleto || ""}\nCPF: ${userData.cpf || ""}`
        );
        window.open(`https://wa.me/55${wppPhone}?text=${text}`);
      } catch (_) {}
    }

    if (timeoutStatus > 0) {
      const timer = setTimeout(() => {
        setTimeoutStatus(timeoutStatus - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [timeoutStatus, shouldRedirect, wppPhone, wppMsg, userData]);

  return (
    <div className="min-h-screen p-4 md:p-8 bg-muted w-full flex items-center justify-center">
      <div className="max-w-2xl w-full gap-y-6 flex flex-col">
        {shouldRedirect && (
          <Card className="p-4 sm:p-6 md:p-8 shadow-sm border-2 border-yellow-100 bg-white/80 backdrop-blur-sm text-center w-full max-w-sm self-center">
            <p className="text-[11px] font-bold text-muted-foreground uppercase tracking-widest mb-1">
              Redirecionamento em
            </p>
            <p className="text-xl sm:text-3xl font-black text-foreground italic tracking-tighter">0:0{timeoutStatus}</p>
          </Card>
        )}

        <Card className="p-5 sm:p-7 md:p-10 shadow-sm border border-border bg-card backdrop-blur-sm text-center relative overflow-hidden">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent opacity-50" />

          <div className="mx-auto w-14 h-14 rounded-full bg-muted flex items-center justify-center mb-6 border border-border">
            <CheckCircle2 className="w-7 h-7 text-yellow-600" />
          </div>

          <h2 className="text-xl font-black text-foreground mb-4 tracking-tight uppercase">
            Contratos enviados!
          </h2>

          <div className="space-y-6">
            <div className="space-y-1">
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                E-mail cadastrado
              </p>
              <p className="text-lg font-bold text-foreground">{userData?.email}</p>
            </div>

            <div className="space-y-1">
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                WhatsApp informado
              </p>
              <p className="text-lg font-bold text-foreground">
                {userData?.telefone || "(não informado)"}
              </p>
            </div>
          </div>

          <Separator className="my-8 opacity-50" />

          {!isAdminMode && (
            <p className="text-xs font-medium text-muted-foreground mb-8 bg-muted py-3 rounded-lg border border-border whitespace-pre-line">
              {contatoMsg}
            </p>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {isAdminMode ? (
              <Button onClick={onReturnToAdmin} variant="outline" className="w-full sm:w-auto h-11 px-8 border-cessaoYellow text-cessaoYellow hover:bg-cessaoYellow/5 font-bold">
                Página Inicial
              </Button>
            ) : (
              <Button onClick={onExit} className="w-full sm:w-auto h-11 px-8 bg-slate-900 text-white hover:bg-slate-800 font-bold">
                Sair do Sistema
              </Button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ConfirmationView;
